"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _MobilePopup = _interopRequireDefault(require("../../../MobilePopup"));
var _contants = require("../contants");
var _DropdownButton = require("../DropdownButton/DropdownButton");
var GlobalStyle = (0, _styledComponents.createGlobalStyle)([".react-responsive-modal-overlay{padding:0;}.react-responsive-modal-modal{max-width:unset;}"]);
var MobileContainer = exports.MobileContainer = function MobileContainer(props) {
  var onSubmit = props.onSubmit,
    label = props.label,
    children = props.children,
    isFiltersMobile = props.isFiltersMobile,
    isInitialOpen = props.isInitialOpen,
    onClear = props.onClear;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(GlobalStyle, null), /*#__PURE__*/_react["default"].createElement(_MobilePopup["default"], {
    label: /*#__PURE__*/_react["default"].createElement(_DropdownButton.DropdownButton, {
      label: label,
      isOpen: false,
      isFiltersMobile: isFiltersMobile
    }),
    options: _contants.MOBILE_POPUP_OPTIONS,
    onClear: onClear,
    closeButtonText: _contants.CLOSE_BUTTON_TEXT,
    onClosePopup: onSubmit,
    withPadding: false,
    isFullscreen: true,
    showCloseButton: true,
    isInitialOpen: isInitialOpen
  }, children));
};